import styled, { css } from 'styled-components';

export type BaseProps = {
	readonly?: boolean;
	textAlign?: 'left' | 'right' | 'center';
	showUpDownArrows?: boolean;
};

const TextInput = styled.input<BaseProps>`
	--_font-size: 12px;
	--_padding-block: 6px;
	display: var(--input-display, inline-block);
	width: var(--input-width, unset);
	font-family: var(--input-font, Inter);
	font-variant-ligatures: none;
	font-size: var(--input-font-size, var(--_font-size));
	color: var(
		--input-color,
		${({ theme, readonly }) => (readonly ? theme.gray[400] : theme.gray[1000])}
	);
	background: none;
	border-color: var(--input-border-color, transparent);
	border-radius: var(--input-border-radius, 2px);
	box-sizing: border-box;
	padding-inline: var(--input-padding-inline, var(--_padding-inline));
	padding-block: var(--input-padding-block, var(--_padding-block));
	caret-color: var(--input-caret-color, unset);
	width: 100%;
	text-align: ${({ textAlign }) => textAlign || 'left'};
	:read-only {
		pointer-events: none;
		cursor: not-allowed;
	}

	:focus {
		outline: none;
	}

	::placeholder {
		color: ${({ theme }) => theme.gray[700]};
		font-weight: 300;
		font-style: italic;
	}

	/* Hide spinner buttons by default */
	&[type='number']::-webkit-inner-spin-button,
	&[type='number']::-webkit-outer-spin-button {
		-webkit-appearance: none;
		margin: 0;
		opacity: 0;
	}

	/* Show spinner buttons only when showUpDownArrows is true */
	${({ showUpDownArrows }) =>
		showUpDownArrows &&
		css`
			&[type='number']::-webkit-inner-spin-button,
			&[type='number']::-webkit-outer-spin-button {
				-webkit-appearance: auto;
				opacity: 1;
				margin-left: 4px;
			}
		`}
`;

export default TextInput;
